// extracted by mini-css-extract-plugin
export default {"registryButton":"QNQiBC","login":"MsDymW","logout":"eixA7R","label":"iL1k3e"};